import { PopoutStateType } from './types';

export const popoutInitialState: PopoutStateType = {
  type: null,
  meta_info: {},
};
